/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { InitViewService } from '@gh/common-shared';
import { Observable } from 'rxjs';
import { CareerEnquiriesRestService } from '@gh/builder-shared-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { SlicedDataSource } from '@gh/core-data';
import { ID } from '@gh/common-shared-data';

@Injectable()
export class CareerEnquiriesBusinessService implements InitViewService {
  constructor(private careerEnquiriesRestService: CareerEnquiriesRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('careerEnquiries'),
    };
  }

  findAllAsDataSource(filter: any): SlicedDataSource<any> {
    return this.careerEnquiriesRestService.findAllAsDataSource(filter);
  }

  onDeleteOrUndelete(careerEnquiryId: ID, status: boolean): Observable<any> {
    return this.careerEnquiriesRestService.markDeleted(careerEnquiryId, status);
  }
}
